import type { ButtonProps } from "@/components/ui/button";

type ButtonVariant = {
  variant?: ButtonProps["variant"];
};

export type NavigationLinkItemProp = {
  label: string;
  href: string;
  icon?: React.ReactNode;
  kind?: "link";
} & ButtonVariant;

export type MenuNavigationItemProp = {
  label: string;
  items: NavigationLinkItemProp[];
  kind: "menu";
  icon?: React.ReactNode;
} & ButtonVariant;

export type NavigationConfig = (
  | NavigationLinkItemProp
  | MenuNavigationItemProp
)[];

export const navConfig = (accessLevel?: string): NavigationConfig => {
  if (accessLevel === "admin") {
    return [
      {
        label: "Documents",
        href: "/folders",
      },
      {
        label: "Admin",
        href: "/admin",
      },
    ];
  }

  if (accessLevel === "active_client" || accessLevel === "return_reviewer") {
    return [
      {
        label: "Documents",
        href: "/folders",
      },
    ];
  }

  return [];
};
